import { definedDicts } from '@hll/full';
import { EService } from '../order-center-order-confirm/components/handling-service/type';

// 费用项type类型。
// type:1 描述:起步价
// type:2 描述:超里程价
// type:3 描述:货运券抵扣
// type:4 描述:其他需求
// type:5 描述:小费
// type:6 描述:车型规格
// type:7 描述:额外补贴
// type:8 描述:额外费用
// type:9 描述:附加费6项(预约费、时段附加费、限行附加费、热点区域附加费、特殊事件附加费、远途附加费)
// type:10 描述:最低消费附加费
// type:11 描述:封顶折扣
// type:12 描述:保险费(暂未启用)
// type:13 描述:搬运费(平台定价)
// type:15 描述:货损保障
// type:16 描述:等候费
// type:17 描述:税额
// type:18 描述:随车意外险
// type:20 描述:前置税费
// type:21 描述:高速路桥费
// type:22 描述:停车费
// type:23 描述:搬运费(司机添加)
// type:24 描述:其他费用
// type:25 描述:逾时等候费
// type:27 描述:点位费
// type:29 描述:运费一口价(不含优惠)
// type:30 描述:平台减免
// type:51 描述:多因素调整费
// type:53 描述:用户报价
// type:56 描述:企业补贴调度
// type:59 描述:司机加价
// type:60 描述:优享服务费
// type:67 描述:专享价优惠
// type:64 描述:优享服务费优惠
// type:69 描述:完单奖励
// type:100 描述:基本路费
// type:101 描述:楼层搬运服务费
// type:102 描述:大件物品服务费
// type:103 描述:返程费
// type:104 描述:超里程每公里价格
// type:107 描述: 节日特惠
// type:0 描述:未知账单类型
// type:9980 描述:用于兼容旧版本

// 优惠类型列表
export const couponTypeList = [3, 7, 30, 56, 64, 67, 69, 107];

export const fromMap = ['home', 'menu', 'orderlist', 'detail'];
export const statVal: Record<string, string> = {
  home: '首页拉货入口',
  menu: '目录下单入口',
  orderlist: '订单列表【再来一单】入口',
  detail: '订单详情页【再来一单】入口',
};

/**
 * kv, key-value
 * vk, value-key
 * kMap, key 为键名的 Map
 * vMap，value为键名的 Map
 * list，业务定义数组
 * const { kv, vk, vMap, kMap, list } = CommodityCodeTypeDict;
 * 所有的企业商品定义
 */
export const CommodityCodeTypeDict = definedDicts([
  {
    key: 'CMD_EP_CARRY_QUOTATION',
    value: 'CMD_EP_CARRY_QUOTATION',
    text: '我来报价',
    porterageType: 3,
    serviceType: EService.OFFER,
  },
  {
    key: 'CMD_EP_CARRY_NEGOTIATE',
    value: 'CMD_EP_CARRY_NEGOTIATE',
    text: '需要搬运(与司机线下商议)',
    porterageType: 2,
    serviceType: EService.OFFLINE,
  },
  {
    key: 'CMD_EP_CARRY_PRICING',
    value: 'CMD_EP_CARRY_PRICING',
    text: '需要搬运（平台计价）',
    porterageType: 1,
    serviceType: EService.PLATFORMCALC,
  },
  {
    key: 'CMD_EP_PAPER_RECEIPT_PRICING',
    value: 'CMD_EP_PAPER_RECEIPT_PRICING',
    text: '企业纸质回单',
    /* 原ops配置Type：3 */
    opsType: 3,
  },
  {
    key: 'CMD_EP_PHOTO_RECEIPT_PRICING',
    value: 'CMD_EP_PHOTO_RECEIPT_PRICING',
    text: '企业拍照回单',
    /* 原ops配置Type：6 */
    opsType: 6,
  },
  {
    key: 'CMD_EP_RETURN_JOURNEY_PRICING',
    value: 'CMD_EP_RETURN_JOURNEY_PRICING',
    text: '企业返程',
    /* 原ops配置Type：5 */
    opsType: 5,
  },
  {
    key: 'CMD_EP_COD_PRICING',
    value: 'CMD_EP_COD_PRICING',
    text: '企业代收货款',
    /* 原ops配置Type：8 */
    opsType: 8,
  },
  {
    key: 'CMD_EP_WAREHOUSING_BY_SEA_PRICING',
    value: 'CMD_EP_WAREHOUSING_BY_SEA_PRICING',
    text: '企业海运入仓',
    /* 原ops配置Type：7 */
    opsType: 7,
  },
] as const); // ⚠️⚠️⚠️ 一定要有 as const，否则业务字典的 TS 类型注释无法生效

/**
 * 商品定义
 * https://huolala.feishu.cn/sheets/S8jtsdDrwh7L69tWUKice1dKngo
*/
export const ProductCodeTypeDict = definedDicts([
  {
    key: 'ATTV_PRD_CATE_BASE',
    value: 'ATTV_PRD_CATE_BASE',
    text: '企业大车快车、企业小车快车',
  },
  {
    key: 'ATTV_PRD_CATE_BARGAIN',
    value: 'ATTV_PRD_CATE_BARGAIN',
    text: '用户议价',
  },
  {
    key: 'ATTV_PRD_CATE_EXPRESS',
    value: 'ATTV_PRD_CATE_EXPRESS',
    text: '特快'
  },
  {
    key: 'ATTV_PRD_CATE_CARPOOL',
    value: 'ATTV_PRD_CATE_CARPOOL',
    text: '拼车'
  },
  {
    key: 'ATTV_PRD_CATE_CONVENIENT',
    value: 'ATTV_PRD_CATE_CONVENIENT',
    text: '新顺路'
  },
  {
    key: 'ATTV_PRD_CATE_CARGO_PRICING',
    value: 'ATTV_PRD_CATE_CARGO_PRICING',
    text: '零担拼车'
  },
] as const); // ⚠️⚠️⚠️ 一定要有 as const，否则业务字典的 TS 类型注释无法生效
// 子商品
export const SubCommodityCodeTypeDict = definedDicts([
  CommodityCodeTypeDict.kMap.CMD_EP_CARRY_NEGOTIATE,
  CommodityCodeTypeDict.kMap.CMD_EP_CARRY_PRICING,
  CommodityCodeTypeDict.kMap.CMD_EP_CARRY_QUOTATION,
  CommodityCodeTypeDict.kMap.CMD_EP_COD_PRICING,
  CommodityCodeTypeDict.kMap.CMD_EP_PAPER_RECEIPT_PRICING,
  CommodityCodeTypeDict.kMap.CMD_EP_PHOTO_RECEIPT_PRICING,
  CommodityCodeTypeDict.kMap.CMD_EP_RETURN_JOURNEY_PRICING,
  CommodityCodeTypeDict.kMap.CMD_EP_WAREHOUSING_BY_SEA_PRICING,
] as const); // ⚠️⚠️⚠️ 一定要有 as const，否则业务字典的 TS 类型注释无法生效

// 搬运服务
export const porterageConfigTypeDict = definedDicts([
  CommodityCodeTypeDict.kMap.CMD_EP_CARRY_NEGOTIATE,
  CommodityCodeTypeDict.kMap.CMD_EP_CARRY_PRICING,
  CommodityCodeTypeDict.kMap.CMD_EP_CARRY_QUOTATION,
] as const);

// 其他需求
export const otherConfigTypeDict = definedDicts([
  CommodityCodeTypeDict.kMap.CMD_EP_COD_PRICING,
  CommodityCodeTypeDict.kMap.CMD_EP_PAPER_RECEIPT_PRICING,
  CommodityCodeTypeDict.kMap.CMD_EP_PHOTO_RECEIPT_PRICING,
  CommodityCodeTypeDict.kMap.CMD_EP_RETURN_JOURNEY_PRICING,
  CommodityCodeTypeDict.kMap.CMD_EP_WAREHOUSING_BY_SEA_PRICING,
] as const);


// 商品渠道
export const agrChannelDict = definedDicts([
  {
    key: 'ATTV_AGR_CHANNEL_XL',
    value: 'ATTV_AGR_CHANNEL_XL',
    text: '小拉渠道'
  },
  {
    key: 'ATTV_AGR_CHANNEL_HLL',
    value: 'ATTV_AGR_CHANNEL_HLL',
    text: '货运渠道'
  }
] as const); // ⚠️⚠️⚠️ 一定要有 as const，否则业务字典的 TS 类型注释无法生效


export const CALC_AUTO_REPEAT_COUNT_LIMIT = 1; // 重新触发估价的次数限制